
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1955"}},[_c('path',{attrs:{"data-name":"Rectangle 2684","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1954","fill":"#adadad"}},[_c('path',{attrs:{"data-name":"Union 22","d":"M17 20a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm12-5a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1z"}}),_c('path',{attrs:{"data-name":"Path 1269","d":"M21 3h-2.5V1.5a1.5 1.5 0 10-3 0V3h-7V1.5a1.5 1.5 0 10-3 0V3H3a3.008 3.008 0 00-3 3v15a3.009 3.009 0 003 3h18a3.009 3.009 0 003-3V6a3.009 3.009 0 00-3-3zM2 6a1 1 0 011-1h18a1 1 0 011 1v2H2zm20.01 13.963a2.007 2.007 0 01-2 2h-16a2.007 2.007 0 01-2-2v-10h20z"}})])])])
          )
        }
      }
    